'use client';

import Image from 'next/image';

import {MockIcon} from '@shared/AppCard/assets/MockIcon';
import {Star} from '@shared/AppCard/assets/Star';

import styles from './AppCard.module.scss';

export type App = {
  packageName: string;
  iconUrl: string;
  appName: string;
  shortDescription: string;
  averageUserRating?: number;
  totalRatings?: number;
};

type Props = {
  analytics?: {
    position: number;
    onClick?: (app: App, position: number) => void;
  };
  app: App;
};

const ZERO_RATING = '0,0';

export const AppCard = ({analytics, app}: Props) => {
  return (
    <a
      href={`/catalog/app/${app.packageName}`}
      itemScope
      itemType="https://schema.org/SoftwareApplication"
      itemProp="operatingSystem"
      content="Android"
      className={styles.wrapper}
      onClick={() => analytics?.onClick?.(app, analytics?.position)}
    >
      <div className={styles.logo}>
        {app.iconUrl ? (
          <Image alt={app.appName} src={app.iconUrl} width={72} height={72} />
        ) : (
          <MockIcon />
        )}
      </div>
      <div className={styles.app}>
        <span className={styles.app__name}>{app.appName}</span>
        <span className={styles.app__description}>{app.shortDescription}</span>
        <span className={styles.app__rating}>
          <Star />
          <span className={styles.app__rating_text}>
            {app?.averageUserRating?.toFixed(1) || ZERO_RATING}
          </span>
        </span>
      </div>
    </a>
  );
};
